// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Bangladesh */
const BD = /^(?:(?:1[13-9]\d|644)\d{7}|(?:3[78]|44|66)[02-9]\d{7})$/;

export default BD;
